import { ProductAccountDTO } from 'api-models'
import {
	GAdminDashboardTable,
	GLoading,
	GSection
} from 'components/basic-blocks'
import { useStores } from 'hooks'
import { useEffect, useState } from 'react'
import { RiErrorWarningLine } from 'react-icons/ri'
import { useUiStore } from 'store'
import { columns } from './columns'

export const NewSetupsTab = () => {
	const { adminStore } = useStores()
	const { loadAccounts, downloadAccounts } = adminStore
	const isLoading = useUiStore((s) => s.isLoading)

	const [state, setState] = useState<any>({})
	const [skip, setSkip] = useState(0)
	const [query, setQuery] = useState({
		account_status: 'SETUP',
		sort: '',
		pageSize: 50,
		skip: 0
	})

	useEffect(() => {
		;(async () => {
			const accounts = await loadAccounts({ ...query, skip })
			setState({ accounts })
		})()
	}, [query.sort, skip])

	const handleSort = (key: string) => {
		setQuery({ ...query, sort: key })
	}

	const pageListener = (page: number) => {
		setQuery({ ...query, skip: page })
	}

	if (!state.accounts) return <GLoading />

	return (
		<>
			<GSection className="pt-1" loading={isLoading('ADMIN_GET_ACCOUNTS')}>
				<GAdminDashboardTable<ProductAccountDTO>
					refreshAction={async () => {
						const accounts = await loadAccounts(query)
						setState({ accounts })
					}}
					downloadAction={async () => {
						await downloadAccounts(query, 'new-setups')
					}}
					isDownloadable={true}
					actionButtonsPlacement="bottom"
					title="New setups"
					setSkip={setSkip}
					skip={skip}
					columns={columns}
					data={state.accounts.data}
					pageSize={query.pageSize}
					sortListener={handleSort}
					pageListener={pageListener}
					sort={query.sort}
					totalCount={state.accounts.total}
					emptyState={
						<div className="flex flex-col items-center justify-center w-full p-8 text-center">
							<RiErrorWarningLine className="w-8 h-8 text-gray-500" />
							<h3 className="mt-2 text-md font-medium text-gray-700">
								No data
							</h3>
						</div>
					}
				/>
			</GSection>
		</>
	)
}
